import { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { Logo } from '@/components/brand/Logo';
import { ApiError, api } from '@/lib/api';

/**
 * 確認リンクの着地点。
 *
 * ここでテナントと初期管理者ができ、そのままログイン済みになる。
 * 遷移先は main.tsx の home に任せる (ロールごとに必ず開ける画面が違うため、
 * 画面パスを直書きしない)。
 */
export function SignupVerifyPage({
  token,
  onSignedIn,
}: {
  token: string | null;
  onSignedIn: () => void;
}) {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (token === null) {
      setError('確認リンクが不正です');
      return;
    }
    let cancelled = false;
    api
      .post('/api/signup/verify', { token })
      .then(() => {
        if (!cancelled) onSignedIn();
      })
      .catch((cause: unknown) => {
        if (cancelled) return;
        setError(cause instanceof ApiError ? cause.message : '通信に失敗しました');
      });
    return () => {
      cancelled = true;
    };
  }, [token, onSignedIn]);

  return (
    <div className="flex min-h-screen flex-col bg-surface">
      <header className="border-b border-line bg-surface-raised px-14 py-5">
        <Link to="/">
          <Logo height={30} className="text-brand-500" />
        </Link>
      </header>

      <main className="mx-auto flex w-full max-w-2xl flex-1 flex-col gap-6 px-6 py-16">
        {error ? (
          <section className="flex flex-col gap-4 border border-line bg-surface-raised px-8 py-8">
            <h1 className="text-xl font-bold">開通できませんでした</h1>
            <p className="text-sm text-alert">{error}</p>
            <p className="text-sm leading-relaxed text-ink-muted">
              リンクの有効期限は 24 時間で、一度使うと無効になります。
              <Link to="/signup" className="text-brand-700 underline">
                もう一度申し込む
              </Link>
              ことができます。
            </p>
          </section>
        ) : (
          <p className="text-sm text-ink-subtle">開通しています…</p>
        )}
      </main>
    </div>
  );
}
